import { Fragment } from 'react';
import { IconButton, useEventCallback } from '@mui/material';
import { createSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { ActionProps } from 'shell/view-models/actions-props';
import { Visibility as VisibilityIcon } from '@mui/icons-material';
import { useFilterTable } from 'shell/hooks/use-filter-table';
import { PersonSearchStorageVM } from 'shell/view-models/search-anpr';

const ActionsList = ({ cell, filterPersonForm }: ActionProps): React.ReactElement => {
  const navigate = useNavigate();
  const filterTable = useFilterTable<PersonSearchStorageVM>();

  const onVisibilityPress = useEventCallback(() => {
    return new Promise((resolve) => {
      filterTable.setValues({ subject: cell });
      navigate({
        pathname: '/sportello/tessera-elettorale/rilascio',
        search: `?${createSearchParams({
          codiceFiscale: cell?.fiscalCode || '',
          nome: cell?.name || '',
          cognome: cell?.surname || '',
          stato: cell?.statePerson || '',
          ricercaNazionale:
            filterPersonForm?.commonSearch?.isNationalResearch?.toString() ||
            filterPersonForm?.subjectData?.isNationalResearch?.toString() ||
            'false',
          idSchedaSoggettoANPR: cell?.anpr || '',
          idFamigliaANPR: cell?.idFamilyAnpr || '',
          idSchedaSoggettoComune: cell?.idSchedaSoggettoComune?.idSchedaSoggetto || '',
          codicePersonaSipo: cell?.codicePersonaSipo || '',
        })}`,
      });
      resolve(cell);
    });
  });

  return (
    <Fragment>
      <IconButton
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onVisibilityPress();
        }}
        aria-label="Visualizza elemento"
        aria-haspopup="true"
        style={{
          padding: '4px',
        }}
      >
        <VisibilityIcon />
      </IconButton>
    </Fragment>
  );
};

ActionsList.displayName = 'Action list release id card component';

export default ActionsList;
